import React, { Fragment, useContext, useMemo, useState } from "react";
import ChatAppContext from "../../../../_helper/Chat";
import { Image, LI, UL } from "../../../../AbstractElements";
import CurrentUser from "./CurrentUser";
import { IoAddCircle } from "react-icons/io5";
import {
  Badge,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import search_icon from "../../../../../src/assets/images/search_user_icon.png";
// import UserList from "./UserList";
import {
  selectUser,
  setIsGroup,
  setSearchUser,
  setUsers,
} from "../../../../utils/userSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { setChatMessages } from "../../../../utils/chatSlice";
import moment from "moment";
// import UserItem from "./UserItem";

const ChatStatus = () => {
  const baseurl = useSelector((store) => store.baseUrl);
  const [userdetails, setUserdetails] = useState(
    JSON.parse(localStorage.getItem("userdetails"))
  );
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
  } = useForm();

  const [modal, setModal] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [activeTab, setActiveTab] = useState("group");
  // const [group_name, setGroupName] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const users = useSelector((state) => state?.users?.users);
  // const searchUser = useSelector((state) => state?.users?.searchUser);
  const selectedUserr = useSelector((state) => state?.users?.selectedUser);
  const isgroup = useSelector((state) => state?.users?.isGroup);

  const dispatch = useDispatch();

  const handleSearchUser = (keyword) => {
    setSearchUser(keyword.toLowerCase()); // Trim & lowercase for better matching
    // dispatch(setSearchUser(keyword));
  };

  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  const handleCheckboxChange = (id) => {
    if (id == "selectAll") {
      if (selectedEmployees.length == filteredUsers.length) {
        setSelectedEmployees([]); // Deselect all
      } else {
        setSelectedEmployees(filteredUsers.map((emp) => emp.employee_id)); // Select all
      }
    } else {
      setSelectedEmployees(
        (prev) =>
          prev.includes(id)
            ? prev.filter((empId) => empId != id) // Deselect the employee
            : [...prev, id] // Select the employee
      );
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const toggle = () => setModal(!modal);

  const onSubmit = async (data) => {
    try {
      // Prepare FormData
      const formData = new FormData();

      // Transform selectedEmployees into the required format
      const mappedEmployees = selectedEmployees.map((id) => ({
        employee_id: id,
      }));

      // Append common and form-specific fields
      formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
      formData.append("PHPTOKEN", localStorage.getItem("id_token") || "");
      formData.append("group_name", data?.group_name || ""); // Fallback to empty string
      formData.append("groupimg", data?.group_image[0] || null); // Fallback to null
      formData.append("creator_id", userdetails?.employee_id || "");
      formData.append("creator_type", userdetails?.user_type || "");
      formData.append("map_emp", JSON.stringify(mappedEmployees)); // Stringify the mapped employees

      // Make API call
      const response = await fetch(`${baseurl}/common_api/savenewgroup/`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();
      const { STATUS, MSG } = result[0] || {};

      if (STATUS === "SUCCESS") {
        // Show success toast
        toast.success("Group created successfully!");
        fetchEmployeeList(); // Refresh employee list
        reset(); // Reset form
        setSelectedEmployees([]); // Clear selected employees
        setSearchText("");
        toggle(); // Close the modal or perform any toggle functionality
      } else {
        // console.error("Failed to create group:", MSG);

        // Show error modal using SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Error",
          text: MSG || "Failed to create group. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error.message);

      // Show unexpected error modal
      Swal.fire({
        icon: "error",
        title: "Unexpected Error",
        text:
          error.message || "An unexpected error occurred. Please try again.",
      });
    }
  };

  const fetchEmployeeList = async () => {
    const formData = new FormData();
    formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
    formData.append("PHPTOKEN", localStorage.getItem("id_token"));
    formData.append("user_id", userdetails?.employee_id);
    formData.append("get_group", "Y");
    formData.append("user_type", userdetails?.user_type);

    try {
      const response = await fetch(`${baseurl}/common_api/getemployee_list/`, {
        method: "POST",
        body: formData,
      });
      const result = await response.json();

      if (result[0]?.STATUS == "SUCCESS") {
        const employeeArr = result[0]?.DATA?.employee_arr;
        dispatch(setUsers(employeeArr));
        // dispatch(selectUser(employeeArr[0]));
      } else {
        console.error("Failed to fetch employee list:", result[0]?.MESSAGE);
        dispatch(setUsers([]));
        // dispatch(selectUser({}));
      }
    } catch (error) {
      console.error("Error fetching employee list:", error.message);
      dispatch(setUsers([]));
      // dispatch(selectUser({}));
    }
  };

  // const fetchChatHistory = async (selectedlineitem, userdetails) => {
  //     if (!selectedlineitem) return; // Exit if no user is selected

  //     // dispatch(setChatMessages([])); // Clear previous messages
  //     // dispatch(setChatLoading({ isLoading: true })); // Show loading indicator

  //     try {
  //       let apiEndpoint = "";
  //       const formData = new FormData();

  //       // Append common fields
  //       formData.append("AUTHORIZEKEY", process.env.REACT_APP_AUTHORIZE_KEY);
  //       formData.append("PHPTOKEN", localStorage.getItem("id_token"));

  //       // Determine API endpoint and specific fields
  //       if (isgroup) {
  //         // Group chat case
  //         apiEndpoint = `${baseurl}/common_api/openhistorygroupchat/`;
  //         formData.append("groupid", selectedlineitem?.group_id);
  //         formData.append("memberid", selectedlineitem?.member_id);
  //       } else {
  //         // Individual chat case
  //         apiEndpoint = `${baseurl}/common_api/openhistorychat/`;
  //         const { employee_id: senderId, user_type: senderType } = userdetails;
  //         formData.append("receiver_id", selectedlineitem.employee_id);
  //         formData.append("receiver_type", selectedlineitem.user_type);
  //         formData.append("sender_id", senderId);
  //         formData.append("sender_type", senderType);
  //       }

  //       // Fetch data from the API
  //       const response = await fetch(apiEndpoint, {
  //         method: "POST",
  //         body: formData,
  //       });

  //       const result = await response.json();
  //       const { STATUS, DATA } = result[0] || {};

  //       if (STATUS == "SUCCESS") {
  //         // Sort and dispatch messages
  //         // const sortedMessages = DATA?.sort((a, b) => a.order_no - b.order_no);
  //         dispatch(setChatMessages(DATA));
  //       } else {
  //         console.error("Failed to fetch chat history:", STATUS);
  //         dispatch(setChatMessages([]));
  //       }
  //     } catch (error) {
  //       console.error("Error fetching chat history:", error.message);
  //       dispatch(setChatMessages([]));
  //     } finally {
  //       // dispatch(setChatLoading({ isLoading: false })); // Reset loading indicator
  //     }
  //   };

  // Memoized filteredUsers: Updates only when users or searchUser changes
  const filteredUsers = useMemo(() => {
    return users
      .filter((user) => user?.employee_id) // Ensure employee_id is available
      .filter((user) =>
        user.name.toLowerCase().includes(searchText.toLowerCase())
      );
  }, [users, searchText]);

  // Deduplicate users by `employee_id` if `activeTab` is "chat", otherwise by `group_id`
  const uniqueUsers = useMemo(() => {
    const seen = new Set();
    return users.filter((user) => {
      const id = activeTab == "chat" ? user?.employee_id : user?.group_id;
      if (!id || seen.has(id)) return false;
      seen.add(id);
      return true;
    });
  }, [users, activeTab]);

  // Filter users based on search
  const filteredListUsers = useMemo(() => {
    return uniqueUsers.filter((user) =>
      user.name.toLowerCase().includes(searchUser.toLowerCase())
    );
  }, [uniqueUsers, searchUser]);

  const formatCreatedDate = (createdDateStr) => {
    if (!createdDateStr) return ""; // Fallback for null/undefined
  
    // Parse the date string (assuming format "DD/MM/YYYY HH:mm:ss A")
    const createdDate = moment(createdDateStr, "DD/MM/YYYY HH:mm:ss A");
    const today = moment().startOf("day"); // Start of today (midnight)
    const yesterday = moment().subtract(1, "day").startOf("day"); // Start of yesterday (midnight)
  
    if (createdDate.isSame(today, "day")) {
      // Show only time if it's today
      return createdDate.format("hh:mm A");
    } else if (createdDate.isSame(yesterday, "day")) {
      // Show "Yesterday" if it's yesterday
      return "Yesterday";
    } else {
      // Show date and time in DD/MM/YY hh:mm A format
      return createdDate.format("DD/MM/YY");
    }
  };

  // return createdDate.format("DD/MM/YY hh:mm A");

  return (
    <Fragment>
      <div className="chat-box">
        <div className="chat-left-aside">
          <CurrentUser />
          {/* <div className="create-group">
            <Button color="primary" className="m-r-10 m-t-10" onClick={toggle}>
              Create group
            </Button>
          </div> */}
          <div className="people-list mt-3" id="people-list">
            {/* <SearchChatList /> */}
            <div className="search">
              <Form className="theme-form d-flex justify-content-between align-items-center">
                <FormGroup className="form-group user-chat-search">
                  <Input
                    className="form-control"
                    type="text"
                    placeholder={
                      activeTab == "chat"
                        ? "Search Contact"
                        : activeTab == "group"
                        ? "Search Group"
                        : "Search"
                    }
                    value={searchUser}
                    onChange={(e) => handleSearchUser(e.target.value)}
                  />
                  <i className="fa fa-search"></i>
                  {/* <img src={search_icon} alt="Search" className="search-img" /> */}
                </FormGroup>
                <FormGroup className="form-group groupadd-btn">
                  <button
                    className="plus-button"
                    onClick={toggle}
                    type="button"
                  >
                    +
                  </button>
                </FormGroup>
              </Form>
            </div>

            {/* Tabs */}
            <div className="tabs">
              <button
                className={activeTab == "group" ? "active" : ""}
                onClick={() => setActiveTab("group")}
              >
                Groups
              </button>
              <button
                className={activeTab == "chat" ? "active" : ""}
                onClick={() => setActiveTab("chat")}
              >
                Chat
              </button>
            </div>

            {filteredListUsers.length > 0 ? (
              <UL attrUL={{ className: "simple-list list custom-scrollbar" }}>
                {filteredListUsers?.length > 0 &&
                  filteredListUsers.map((user, index) => {
                    return (
                      <>
                      
                      <LI
                        key={user?.employee_id || user?.group_id || index} // Unique key
                        attrLI={{
                          className: `clearfix border-0 d-flex align-items-center left-side-user-item user-item ${
                            selectedUserr?.employee_id
                              ? selectedUserr.employee_id == user?.employee_id
                                ? "selected"
                                : ""
                              : selectedUserr?.group_id == user?.group_id
                              ? "selected"
                              : ""
                          }`,

                          onClick: () => {
                            // Set isGroup based on user type
                            // Dispatch the selected user to the store

                            if (user?.group_id) {
                              dispatch(setIsGroup(true));
                            } else if (user?.employee_id) {
                              dispatch(setIsGroup(false));
                            }
                            dispatch(selectUser(user));

                            // fetchChatHistory(user,userdetails)
                            // fetchAllNotificationsCount();
                          },
                        }}
                      >
                        {/* <span className="last-seen-text">12:39 am</span> */}
                        <div className="time-display">{formatCreatedDate(user?.created_date)}</div>
                        <Image
                          attrImage={{
                            src: `${user?.photo_path || user?.groupphoto}`,
                            className: "rounded-circle user-image",
                            alt: "",
                          }}
                        />
                        
                        <div className="about d-flex justify-content-between">
                          <div className="search-user-name">
                            {user?.name && user?.name?.length > 25
                              ? `${user.name.slice(0, 25)}...`
                              : user.name}
                          </div>
                          {user?.unread_message_count != "" && (
                            <div className="status">
                              <Badge className="notify-individual" color="dark">
                                {user?.unread_message_count ||
                                  user?.unrea_group_message_count}
                              </Badge>
                            </div>
                          )}
                          {/* <div className="status">
                              <Badge className="notify-individual" color="dark">
                                8
                              </Badge>
                            </div> */}
                        </div>
                      </LI>
                      </>
                    );
                  })}
              </UL>
            ) : (
              <p className="text-center mt-2">
                No results found for <strong>'{searchUser}'</strong>
              </p>
            )}
          </div>
        </div>
      </div>

      {/* create group modal start  */}
      <Modal
        isOpen={modal}
        toggle={toggle}
        keyboard={false}
        backdrop="static"
        size="xl"
        className="create-group-modal custom-modal"
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader
            toggle={() => {
              toggle();
              setSelectedEmployees([]);
              setSearchText("");
              reset();
              clearErrors("selectedEmployees"); // Clear error when modal is canceled
            }}
            className="custom-modal-header"
          >
            Create group
          </ModalHeader>
          <ModalBody className="custom-modal-body">
            <Container>
              <Row>
                <Col md={6} className="custom-image-col">
                  <Image
                    attrImage={{
                      className: "img-fluid group-image",
                      src: `${baseurl}/public/images/supportportal/create_group.png`,
                      alt: "create_group",
                    }}
                  />
                </Col>
                <Col md={6} className="custom-form-col">
                  <Row>
                    <Col sm="12" xl="12">
                      <Form className="theme-form custom-form">
                        <FormGroup
                          className={`row formdiv-margin ${
                            isMobile ? "" : "mb-2"
                          } custom-form-group`}
                        >
                          <Label
                            className={`col-sm-4 col-form-label timesheet-label ${
                              isMobile ? "text-start" : "text-end"
                            } custom-label`}
                            htmlFor="inputGroupName"
                          >
                            Group Name:
                          </Label>
                          <Col sm="7">
                            <input
                              className="form-control register-full input-register select-font custom-input"
                              type="text"
                              id="inputGroupName"
                              {...register("group_name", {
                                required: "Group name is required",
                              })}
                            />
                            {errors.group_name && (
                              <p className="text-danger">
                                {errors.group_name.message}{" "}
                              </p>
                            )}
                          </Col>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col sm="12" xl="12">
                      <Form className="theme-form custom-form">
                        <FormGroup
                          className={`row formdiv-margin ${
                            isMobile ? "" : "mb-2"
                          } custom-form-group`}
                        >
                          <Label
                            className={`col-sm-4 col-form-label timesheet-label ${
                              isMobile ? "text-start" : "text-end"
                            } custom-label`}
                            htmlFor="selectEmployeeDropdown"
                          >
                            Select Employee:
                          </Label>
                          <Col sm="7">
                            <Dropdown
                              isOpen={dropdownOpen}
                              toggle={toggleDropdown}
                              className="w-100 custom-dropdown"
                            >
                              <DropdownToggle
                                caret
                                className="form-control register-full input-register select-font text-start employee-dropdown custom-dropdown-toggle"
                              >
                                {selectedEmployees.length > 0
                                  ? `${selectedEmployees.length} selected`
                                  : "Select Employee"}
                              </DropdownToggle>
                              <DropdownMenu className="w-100 p-2 custom-dropdown-menu">
                                <div className="mb-2">
                                  <Input
                                    type="text"
                                    placeholder="Search"
                                    value={searchText}
                                    onChange={handleSearch}
                                    className="form-control search-employee custom-search-input"
                                  />
                                </div>
                                {filteredUsers.length > 0 && (
                                  <div className="form-check select-emp-dropdownlist custom-select-all">
                                    <input
                                      type="checkbox"
                                      id="selectAll"
                                      className="form-check-input employee-selectall-checkbox custom-checkbox"
                                      checked={
                                        selectedEmployees.length ===
                                        filteredUsers.length
                                      }
                                      onChange={() =>
                                        handleCheckboxChange("selectAll")
                                      }
                                    />
                                    <label
                                      htmlFor="selectAll"
                                      className="form-check-label custom-checkbox-label"
                                    >
                                      Select All
                                    </label>
                                  </div>
                                )}

                                {filteredUsers.length > 0 ? (
                                  filteredUsers.map((user) => (
                                    <div
                                      key={user?.employee_id}
                                      className="form-check select-emp-dropdownlist custom-dropdown-item"
                                    >
                                      <input
                                        type="checkbox"
                                        id={user?.employee_id}
                                        className="form-check-input employee-checkbox custom-checkbox"
                                        checked={selectedEmployees.includes(
                                          user?.employee_id
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(
                                            user?.employee_id
                                          )
                                        }
                                      />
                                      <label
                                        htmlFor={user?.employee_id}
                                        className="form-check-label custom-checkbox-label"
                                      >
                                        {user?.name}
                                      </label>
                                    </div>
                                  ))
                                ) : (
                                  <div>
                                    <p className="text-center">
                                      No results found for{" "}
                                      <strong>'{searchText}'</strong>
                                    </p>
                                  </div>
                                )}
                              </DropdownMenu>
                            </Dropdown>
                            {/* Conditional error rendering for selected employees */}
                            {/* {errors.selectedEmployees && (
                              <p className="text-danger">
                                {errors.selectedEmployees.message}
                              </p>
                            )} */}
                          </Col>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col sm="12" xl="12">
                      <Form className="theme-form custom-form">
                        <FormGroup
                          className={`row formdiv-margin ${
                            isMobile ? "" : "mb-2"
                          } custom-form-group`}
                        >
                          <Label
                            className={`col-sm-4 col-form-label timesheet-label ${
                              isMobile ? "text-start" : "text-end"
                            } custom-label`}
                          >
                            Group Image:
                          </Label>
                          <Col sm="7">
                            <input
                              className="form-control custom-file-input"
                              type="file"
                              accept="image/jpeg, image/png"
                              id="inputGroupImage"
                              style={{ padding: "6px" }}
                              {...register("group_image", {
                                validate: (fileList) => {
                                  if (fileList.length == 0) return true; // Optional

                                  const file = fileList[0];

                                  const allowedTypes = [
                                    "image/jpeg",
                                    "image/png",
                                  ];

                                  if (!allowedTypes.includes(file.type)) {
                                    return "Only JPEG and PNG files are allowed";
                                  }

                                  if (file.size > 2 * 1024 * 1024) {
                                    return "File size should not exceed 2MB";
                                  }

                                  return true;
                                },
                              })}
                            />
                            {errors.group_image && (
                              <p className="text-danger">
                                {errors.group_image.message}
                              </p>
                            )}
                          </Col>
                        </FormGroup>
                      </Form>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </ModalBody>
          <ModalFooter className="custom-modal-footer">
            <Button color="primary" className="custom-save-btn" type="submit">
              Save
            </Button>
            <Button
              color="secondary"
              className="custom-cancel-btn"
              onClick={() => {
                toggle();
                setSelectedEmployees([]);
                setSearchText("");
                reset();
                clearErrors("selectedEmployees"); // Clear error when modal is canceled
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      {/* create group modal end  */}
    </Fragment>
  );
};
export default ChatStatus;
